import React from "react";
import CameraButton from "./CameraButton";
import LeaveRoomButton from "./LeaveRoomButton";
import MicButton from "./MicButton";
// import SwitchToScreenSharingButton from "./SwitchToScreenSharingButton";
import { connect } from "react-redux";
import SwitchToScreenSharingButton from "./SwitchToScreenSharingButton";
// import ParticipantsBtn from "./ParticipantsBtn";
// import ChatBtn from "./ChatBtn";
// import Morebtn from "./Morebtn";
// import Recording from "./Recording";

const VideoButtons = ({ connectOnlyWithAudio, roomId, userId, hostLeave, isRoomHost, meetEnd, frontCam, stable,frontMic,isSas, hostLink, guestLink }) => {
  // const { connectOnlyWithAudio } = props;

  return (
    // <div className="video_buttons_container">
    //   <ParticipantsBtn/>
    //   <MicButton />
    //   {!connectOnlyWithAudio && <CameraButton />}
    //   <LeaveRoomButton />
    //   {!connectOnlyWithAudio && <SwitchToScreenSharingButton />}
    //   <ChatBtn/>
    //   {/* <Recording/> */}
    //   <Morebtn  roomId={roomId}/>
    //   {/* <button>chat</button> */}
    // </div>
    <>
      <div></div>
      <div className="meetingButtons">
      <button>  <MicButton stable={stable} frontMic={frontMic}/></button>
      <button>  {!connectOnlyWithAudio && <CameraButton frontCam={frontCam} stable={stable}/>}</button>
        {/* <img className="videoBtn" src="../assets/icons/mic-small.svg" alt="" />
        <img
          className="videoBtn"
          src="../assets/icons/video-small.svg"
          alt=""
        /> */}
         
      <button> {!connectOnlyWithAudio && <SwitchToScreenSharingButton />}</button>
      </div>
      {/* <buttpn className="dangerBtn">Leave Meeting</buttpn> */}
    
      <LeaveRoomButton hostLeave={hostLeave} isRoomHost={isRoomHost} hostId={roomId} meetEnd={meetEnd} isSas={isSas} hostLink={hostLink} guestLink={guestLink} userId={userId}/>
    </>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStoreStateToProps)(VideoButtons);
